<header class="navbar-table">
  <ng-container
    class="order-nav-full"
    *ngTemplateOutlet="orderNavContainer"
  ></ng-container>

  <a class="open-nav-btn" (click)="openMobileNav()">
    <i class="fas fa-bars"></i>
  </a>

  <img class="logo" src="assets\img\Logo_Horizontal.svg" />

  <lang-switch></lang-switch>

  <div #hello class="hello-user" [class.is-active]="displayUserOptionsPanel">
    <div class="user-descr">
      {{ "translate.general.hello" | translate }}, &nbsp;
      <strong (click)="toggleUserOptions(userOptions)"
        >{{ currentUser.userDescr }}
        <span *ngIf="displayCurClinic && curClinic">
          | {{ curClinic.text }}</span
        >
      </strong>
    </div>

    <div class="user-icon" (click)="toggleUserOptions(userOptions)">
      <i class="fas fa-user"></i>
    </div>

    <p-popover
      #userOptions
      [dismissable]="true"
      (onShow)="displayUserOptionsPanel = true"
      (onHide)="displayUserOptionsPanel = false"
      class="userOptionsPanel"
      appendTo="body"
    >
      <div class="user-options-container">
        <div *ngFor="let m of userMenuOptions" class="user-menu-option">
          <a (click)="userOptionClicked(m)">{{ m.title }}</a>
        </div>
      </div>
    </p-popover>
  </div>

  <img
    class="icon-notifications"
    [class.is-active]="displayNotificationPanel"
    [src]="
      unreadNotificationsCnt > 0
        ? 'assets\\img\\Bell_Alert.svg'
        : 'assets\\img\\Bell.svg'
    "
    (click)="
      userNotifications.length > 0 ? toggleNotifications(notifications) : null
    "
    [class.t-pointer]="userNotifications.length > 0"
  />
</header>

<p-popover
  #notifications
  [dismissable]="true"
  (onShow)="displayNotificationPanel = true"
  (onHide)="displayNotificationPanel = false"
  class="userNotificationPanel"
>
  <div
    class="notification-container"
    [class.is-rtlx]="isRTL"
    [class.is-ltrx]="!isRTL"
  >
    <div
      *ngFor="let n of userNotifications"
      class="notification"
      [class.highlight]="n.importantSw"
      (click)="onNotificationClicked(n, notifications)"
      [class.unread]="!n.readSw"
    >
      <p [class.unread]="!n.readSw" [class.highlight]="n.importantSw">
        {{ n.text }}
      </p>
      <span class="n-timestamp">{{
        n.timestamp | date: "HH:mm - dd.MM.yy"
      }}</span>
    </div>
  </div>
</p-popover>

<ng-template #orderNavContainer>
  <div *ngIf="displayBackToOrder" class="order-nav-container">
    <button class="t-button-outline btn-back" (click)="goBackToOrder()">
      {{ "translate.navbar.backToOrder" | translate }}
    </button>
  </div>

  <div *ngIf="displayBackToInbox" class="order-nav-container">
    <button class="t-button-outline btn-back" (click)="goToInbox()">
      {{ "translate.navbar.backToInbox" | translate }}
    </button>

    <div class="order-page-icons" *ngIf="orderNavPrevSw || orderNavNextSw">
      &nbsp;
      <a
        class="icon-order-page"
        [class.disabled]="!orderNavPrevSw"
        (click)="goToPrevOrder()"
        [tooltip]="'translate.general.prev' | translate"
        ><i class="fas fa-angle-right ltr-rotate-y"></i
      ></a>
      &nbsp;
      <a
        class="icon-order-page"
        [class.disabled]="!orderNavNextSw"
        (click)="goToNextOrder()"
        [tooltip]="'translate.general.next' | translate"
        ><i class="fas fa-angle-left ltr-rotate-y"></i
      ></a>
    </div>

    <div *ngIf="displayQCStats" class="qc-status-container">
      <div class="qc-status-separator"></div>
      <div class="qc-status-label">QC</div>

      <div class="qc-status-buttons">
        <ng-container
          *ngIf="qcStatus === QCStatusEnum.UPCOMING_QC && !allowEditQCStatus"
        >
          <button class="t-button-outline" [disabled]="true">ממתין</button>
        </ng-container>

        <ng-container
          *ngIf="!(qcStatus === QCStatusEnum.UPCOMING_QC && !allowEditQCStatus)"
        >
          <button
            *ngIf="allowEditQCStatus || qcStatus == QCStatusEnum.FAILED_QC"
            class="t-button-outline"
            [class.failed]="qcStatus == QCStatusEnum.FAILED_QC"
            [disabled]="
              !allowEditQCStatus ||
              qcStatus == QCStatusEnum.FAILED_QC ||
              savingOrderQCStatus
            "
            (click)="updateQCStatus(QCStatusEnum.FAILED_QC)"
          >
            לא עבר
          </button>
          <button
            *ngIf="
              allowEditQCStatus ||
              (qcStatus != QCStatusEnum.FAILED_QC &&
                qcStatus != QCStatusEnum.UPCOMING_QC)
            "
            class="t-button-outline"
            [class.passed]="
              qcStatus != QCStatusEnum.FAILED_QC &&
              qcStatus != QCStatusEnum.UPCOMING_QC
            "
            [disabled]="
              !allowEditQCStatus ||
              (qcStatus != QCStatusEnum.FAILED_QC &&
                qcStatus != QCStatusEnum.UPCOMING_QC) ||
              savingOrderQCStatus
            "
            (click)="updateQCStatus(QCStatusEnum.PASSED_QC)"
          >
            עבר
          </button>
        </ng-container>

        <ng-container *ngIf="currentOrder.qcStatusUserName">
          <div class="qc-status-user-name">
            &nbsp; ({{ currentOrder.qcStatusUserName }})
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
